/* tslint:disable */
/* eslint-disable */
/**
 * PokerWise Backoffice Auth Management API
 * API for managing backoffice user login, logout, and authorization.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export {};
